/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OverlayModule} from '@angular/cdk/overlay';
import {MdOptionModule, MdCommonModule} from '@angular/material/core';
import {MdAutocomplete} from './autocomplete';
import {
  MdAutocompleteTrigger,
  MD_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER,
} from './autocomplete-trigger';
export class MdAutocompleteModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdOptionModule, OverlayModule, MdCommonModule, CommonModule],
  exports: [MdAutocomplete, MdOptionModule, MdAutocompleteTrigger, MdCommonModule],
  declarations: [MdAutocomplete, MdAutocompleteTrigger],
  providers: [MD_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdAutocompleteModule_tsickle_Closure_declarations() {
/** @type {?} */
MdAutocompleteModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdAutocompleteModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
